import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { HTTP_ERROR_MESSAGES } from '../constants/http-error-messages.constant';
import {
  HttpErrorAction,
  HttpErrorMessage,
  HttpErrorType,
} from '../types/http-error.type';

/**
 * The user-facing message for an error class. `action` only changes the wording
 * for the errors whose message depends on what the caller was doing; it is
 * ignored for the rest.
 */
export const httpErrorMessage = (
  type: HttpErrorType,
  action: HttpErrorAction = 'view',
): HttpErrorMessage => {
  const message = HTTP_ERROR_MESSAGES[type];
  return typeof message === 'string' ? message : message[action];
};

/**
 * `ErrorInterceptor` rethrows a bare message string rather than the
 * `HttpErrorResponse`, so the message is what usually identifies a 403 - but
 * cover the un-intercepted shapes too rather than assume every caller sees the
 * interceptor's rewrite.
 */
export const isForbiddenError = (error: unknown): boolean => {
  if (typeof error === 'string') {
    return error === httpErrorMessage('forbidden');
  }

  if (error instanceof HttpErrorResponse) {
    return error.status === HttpStatusCode.Forbidden;
  }

  return (
    error instanceof Error && error.message === httpErrorMessage('forbidden')
  );
};
